import { Component, OnInit, Input } from "@angular/core";

import { TokenStorageService } from "src/app/_services/token-storage.service";
import { Router } from "@angular/router";
import { ClaveService } from "src/app/_services/clave.service";
import { SamlRequest } from "src/app/model/samltoken";
import { ServicioGeneral } from "src/app/_services/servicio-general.service";
import { NotificationReadService } from "src/app/_services/notificacion-read.service";
import { ClientLoaderService } from "src/app/core/util/client-loader.service";

@Component({
  selector: "app-header-emvs",
  templateUrl: "./header-emvs.component.html",
  styleUrls: ["./header-emvs.component.scss"],
})
export class HeaderEmvsComponent implements OnInit {
  //@Input() RolUsuario: RolUsuario;

  private roles: string[] = [];
  isLoggedIn = false;
  showAdminBoard = false;
  showModeratorBoard = false;
  usuario: any = [];
  miData: any = [];
  totalNotificaciones;
  logoHeaderUrl = '';
  loginType: string = 'both';

  constructor(
    private tokenStorageService: TokenStorageService,
    private _claveservice: ClaveService,
    private router: Router,
    private notificacionService: NotificationReadService,
    private clientLoader: ClientLoaderService,
  ) {}

  ngOnInit(): void {
    this.logoHeaderUrl = this.clientLoader.getHeaderLogoUrl();
    this.loginType = this.clientLoader.getLoginType();
    this.isLoggedIn = !!this.tokenStorageService.getToken();

    if (this.isLoggedIn) {
      //this.getRolUsuario();
      const user = this.tokenStorageService.getUser();
      this.checkNotificaciones();
      this.usuario = user;
    }
  }

  logout(): void {
    this.tokenStorageService.signOut();
    window.location.reload();
  }

  isVisible = true;

  toggleDisplay() {
    this.isVisible = !this.isVisible;
  }

  reload() {
    this.router.navigateByUrl("/login");
  }

  /*
    getRolUsuario() {
      return this.serviciogeneral.getRolUsuario().subscribe((data) => {
        this.miData = data;     
      });
    }
    */

  checkNotificaciones() {
    this.notificacionService
      .getAlertMap()
      .subscribe((map: Map<string, string>) => {
        this.totalNotificaciones = map.get("totales");
      });
  }

  redireccion(): void {
    this._claveservice.getSamlRequest().subscribe({
      next: async (data: SamlRequest) => {
        this.post(data.nodeService, {
          SAMLRequest: data.SamlRequest,
          RelayState: data.RelayState,
        });
      },
    });
  }

  post(path: string, params: any): void {
    let method = "post";
    var form = document.createElement("form");
    form.setAttribute("method", method);
    form.setAttribute("action", path);
    for (var key in params) {
      if (params.hasOwnProperty(key)) {
        var hiddenField = document.createElement("input");
        hiddenField.setAttribute("type", "hidden");
        hiddenField.setAttribute("name", key);
        hiddenField.setAttribute("value", params[key]);
        form.appendChild(hiddenField);
      }
    }
    document.body.appendChild(form);
    form.submit();
  }
  navegaSeccion(ruta: string){
    this.router
    .navigate(["login"], { skipLocationChange: true })
    .then(() => {
      this.router.navigateByUrl(ruta);
    });
  }
}
